import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular//http';
import { User } from '../_models/index';
import 'rxjs/add/operator/toPromise';
import { AuthHttp } from 'angular2-jwt';
import { environment } from '../../environments/environment';

@Injectable()

export class ManageAgentServices {

    backendUrl: any;
    TOKEN: any;
    headers: any;
    options: any;
    secret: any;

    api = "/restagents/"

    constructor(private http: AuthHttp) {
        // this.backendUrl = environment.url;
        this.backendUrl=window.location.origin
        this.backendUrl+="/apis"
        this.secret = environment.secret;
    }

     getallNotificationConfiguration() {
        return this.http.get(`${this.backendUrl}${this.api}all-notification-data/` , this.jwt_new()).map((response: Response) => response.json());
    }

    getallNotificationDataById(rest_id:any,id:any) {
        return this.http.get(`${this.backendUrl}${this.api}notification-data-by-id/${rest_id}/${id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    getUsernamesearchdata(name:any,rest_id:any) {
        return this.http.get(`${this.backendUrl}${this.api}getusername_search_data/${name}/${rest_id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    getUsernameshowdata(rest_id:any,id:any) {
        return this.http.get(`${this.backendUrl}${this.api}getusername_show_data/${rest_id}/${id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    AllBranchesDataByManageAgent(rest_id:any) {
        return this.http.get(`${this.backendUrl}${this.api}manage_agent_branchdata/${rest_id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    AllNotificationDropdownConfig(rest_id:any) {
        return this.http.get(`${this.backendUrl}${this.api}notification_dropdown/${rest_id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    UpdateManageAgentDataConfig(data) {
        return this.http.post(`${this.backendUrl}${this.api}update_restaurant_data_agent/` ,data , this.jwt_new()).map((response: Response) => response.json());
    }

    AddManageAgentNew(data) {
        return this.http.post(`${this.backendUrl}${this.api}add_restaurant_data_agent/` ,data , this.jwt_new()).map((response: Response) => response.json());
    }

    AllFoodBotTeamSenderId(rest_id:any) {
        return this.http.get(`${this.backendUrl}${this.api}getfoodbotteamsender_id/${rest_id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    private jwt_new() {
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.headers.append('Authorization', this.TOKEN)
        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }

    private jwt() {
        // create authorization header with jwt token
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        let headers = new Headers({ 'Authorization': this.TOKEN });
        return new RequestOptions({ headers: headers });
    }
}


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_services/manageagent.service.ts